import {caw_onChangeListener} from "../logic/form/form-utils";
import {getAlternateColor, getBackgroundColorOfClass} from "../common/colors";
import {EventBus} from "../classes/misc/event-bus";

export function setupData() {
    setupPageData();
    setupVdxEventBus();
    setupColors();
}

export function setupPageData() {
    // pageData contains data specific to the page, created in EntServlet.java after the
    // child servlet of the page executes (eg after ListAct.java runs).
    const pageDataEl = document.getElementById('pageData');
    if (!pageDataEl)
        return;

    GlobalEnt.pageData = JSON.parse(pageDataEl.innerText);
    GlobalEnt.contextPath = GlobalEnt.pageData.contextPath;
}

export function setupVdxEventBus() {
    try {
        GlobalEnt.vdxEventBus = new EventBus('vdx-event-bus');

        let frm = document.Frm ? document.Frm : document.querySelector('form');
        if (frm) {
            GlobalEnt.vdxEventBus.on('dnd-in-updated', ({detail}) => {
                // Trigger save/cancel buttons to appear.
                caw_onChangeListener(frm);
            });
        }
    } catch (err) {
        console.error(err);
    }
}

export function setupColors() {
    const overridingColor = getBackgroundColorOfClass('bgColorMinor');
    if (overridingColor) {
        Colors.CyberAuditWeb = overridingColor;
        Colors.CyberAuditWebLite = getAlternateColor(overridingColor);
    }
}